var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-public-job-board container-md col-lg-11 col-md-11"},[_c('h4',{staticClass:"text-primary mt-2 mb-4"},[_vm._v("Document Library")]),_c('CCard',[_c('CCardBody',[_c('UploadOrgOnBoardDocs',{staticClass:"pb-3"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }